import { render } from "./BrandAntenneSteiermark.vue?vue&type=template&id=8eb0e794"
import script from "./BrandAntenneSteiermark.vue?vue&type=script&lang=ts"
export * from "./BrandAntenneSteiermark.vue?vue&type=script&lang=ts"

import "./BrandAntenneSteiermark.vue?vue&type=style&index=0&id=8eb0e794&lang=scss"
script.render = render

export default script